import BallsPerOverSettings from "./BallsPerOverSettings";
export default BallsPerOverSettings;
